import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import { ANCHOR, CONTACT, SOCIAL } from 'common/consts/common';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import { EXTERNAL_LINK } from 'common/consts/common';

import messages from './Footer.intl.js';
import CommonMessages from 'common/messages/Layout.intl';

import styles from './Footer.module.scss';

import { Container } from 'common/components/Layout/Layout';

import iso9001Logo from 'common/images/iso-9001.jpg';
import iso27001Logo from 'common/images/iso-27001.jpg';
import iqnetLogo from 'common/images/iqnet.jpg';
import logo from 'common/images/logo_th_white.svg';
import GPWLogo from 'common/images/GPW_logo_BW.png';

import LanguageService from 'services/Language.service';

@injectIntl
export default class Footer extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  currentLanguage = LanguageService.getLang();

  getCurrentYear() {
    return new Date().getFullYear();
  }

  render() {
    const { className } = this.props;

    return (
      <div className={styles.BackgroundWrapper}>
        <Container className={styles.Container}>
          <div className={`${className} ${styles.Footer}`}>
            <div className={styles.FooterCompanyColumn}>
              <Link to={ANCHOR.HOME[this.currentLanguage]}>
                <img src={logo} className={styles.FooterLogo} alt="TH-logo" />
              </Link>
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.intl.formatMessage(
                    messages.adressCountryName
                  )
                }}
              />
              <a
                href={`mailto:${CONTACT.GENERAL}`}
                className={styles.FooterCompanyMail}
              >
                hello@tenderhut.com
              </a>
              <div className={styles.FooterIconsWrapper}>
                <a
                  href={SOCIAL.LINKEDIN}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className={styles.FooterIcon}
                >
                  <FontAwesomeIcon icon={['fab', 'linkedin-in']} />
                </a>
                <a
                  href={SOCIAL.FACEBOOK}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className={styles.FooterIcon}
                >
                  <FontAwesomeIcon icon={['fab', 'facebook-f']} />
                </a>
              </div>
              <div className={styles.NewConnectWrapper}>
                <a
                  href={EXTERNAL_LINK.GPW}
                  title="GPW"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={GPWLogo}
                    className={styles.NewConnectLogo}
                    alt="GPWLogo"
                  />
                </a>
              </div>
              <div className={styles.IsoLogosWrapper}>
                <img src={iqnetLogo} alt="Iq net sign" />
                <img src={iso9001Logo} alt="Iso 9001 sign" />
                <img src={iso27001Logo} alt="Iso 27001 sign" />
              </div>
            </div>
            <div className={styles.LinksWrapper}>
              <ul className={styles.FooterLinksList}>
                <li>
                  <Link
                    to={ANCHOR.COMPANIES[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.ourCompanies)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.MISSIONANDVISION[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(
                      CommonMessages.missionAndVision
                    )}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.STRATEGY[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.strategy)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.SYNERGY[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.synergy)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.AUTHORITIES[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.authorities)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.CORPORATEGOVERNANCE[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(
                      CommonMessages.corporateGovernance
                    )}
                  </Link>
                </li>
              </ul>
              <ul className={styles.FooterLinksList}>
                <li>
                  <Link
                    to={ANCHOR.TEAMOFEXPERTS[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(
                      CommonMessages.teamOfExperts
                    )}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.CASESTUDIES[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.caseStudies)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.JOBOFFERS[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.jobOffers)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.CSR[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.CSR)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.HISTORY[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.history)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.CONTACT[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.contact)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.WHISTLEBLOWING[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(
                      CommonMessages.whistleblowing
                    )}
                  </Link>
                </li>
              </ul>
              <ul className={styles.FooterLinksList}>
                <li>
                  <Link
                    to={ANCHOR.PRESSROOM[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.pressRoom)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.NEWS[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.news)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.MEDIAABOUTUS[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.mediaAboutUs)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.REPORTS[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.reports)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.RODO_POLICY[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.rodoPolicy)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.ZSZ_POLICY[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.zszPolicy)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={ANCHOR.TERMS_OF_USE[this.currentLanguage]}
                    className={styles.FooterColumnLink}
                  >
                    {this.props.intl.formatMessage(CommonMessages.termsOfUse)}
                  </Link>
                </li>
              </ul>
            </div>
            <div className={styles.FooterHorizontalRule} />
            <h4 className={styles.FooterYearCompany}>
              &copy; {this.getCurrentYear()} TenderHut SA
            </h4>
          </div>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/components/Footer/Footer.js